/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

/**
 * Represent a tag inside input-mail
 */
export class MailTag {
  /**
   * Value o tag
   */
  public value: string;
  /**
   * Is the tag wrong ?
   */
  public hasError: boolean;

  constructor(value: string, hasError?: boolean) {
    this.value = value;
    this.hasError = hasError ?? false;
  }

  public toString(): string {
    return this.value;
  }
}
